import React, { useEffect, useState } from "react";
import { getAllCategories } from "../services/categoryService";
import { useNavigate } from "react-router-dom";

const SideBarCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getAllCategories();
        if (data.success) {
          setCategories(data.categories);
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (categorySlug) => {
    navigate(`/${categorySlug}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="sidebar bg-white shadow-sm p-3 rounded">
      <h5 className="text-dark fw-bold mb-3 text-center">📌 News Categories</h5>

      {loading ? (
        <div className="text-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : categories.length > 0 ? (
        <ul className="list-group">
          {categories.map((category) => (
            <li
              key={category.slug}
              className="list-group-item list-group-item-action text-dark fw-semibold rounded-3 mb-2" // Added mb-2 for spacing
              onClick={() => handleCategoryClick(category.slug)}
              style={{ cursor: "pointer", transition: "0.3s" }}
            >
              {category.name}
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-center text-muted py-3">No categories found.</div>
      )}
    </div>
  );
};

export default SideBarCategories;
